import React from 'react';
import { FiTrendingUp } from 'react-icons/fi';
import CommunicationsSidePanel from './CommunicationsSidePanel.jsx';
import {
  PanelStatRow,
  PanelStatLabel,
  PanelStatValue,
} from './communicationsPageStyles.js';
import { formatCurrency } from '../../services/communications/communicationsPresenters.js';

export function ProductivitySidebar({ productivity, collapsed, onExpand, onCollapse }) {
  if (!productivity) return null;

  const billablePct = productivity.billableHoursTarget
    ? Math.round((productivity.billableHours / productivity.billableHoursTarget) * 100)
    : 0;

  return (
    <CommunicationsSidePanel
      side="left"
      collapsed={collapsed}
      onExpand={onExpand}
      onCollapse={onCollapse}
      expandedWidth="260px"
      title="Productivity"
      subtitle="ERP preview"
      railIcon={<FiTrendingUp size={20} />}
      expandAriaLabel="Expand productivity panel"
      collapseAriaLabel="Collapse productivity panel"
    >
      <PanelStatRow>
        <PanelStatLabel>Contract progress</PanelStatLabel>
        <PanelStatValue>{productivity.contractProgressPct}%</PanelStatValue>
      </PanelStatRow>
      <PanelStatRow>
        <PanelStatLabel>Billable hours</PanelStatLabel>
        <PanelStatValue>
          {productivity.billableHours} / {productivity.billableHoursTarget}
        </PanelStatValue>
        <div style={{ fontSize: '0.75rem', color: '#999', marginTop: 4 }}>{billablePct}% of target</div>
      </PanelStatRow>
      <PanelStatRow>
        <PanelStatLabel>Team utilization</PanelStatLabel>
        <PanelStatValue>{productivity.teamUtilizationPct}%</PanelStatValue>
      </PanelStatRow>
      <PanelStatRow>
        <PanelStatLabel>Budget burn</PanelStatLabel>
        <PanelStatValue>{formatCurrency(productivity.budgetSpent)}</PanelStatValue>
        <div style={{ fontSize: '0.75rem', color: '#999', marginTop: 4 }}>
          of {formatCurrency(productivity.budgetTotal)}
        </div>
      </PanelStatRow>
      <PanelStatRow style={{ borderBottom: 'none' }}>
        <PanelStatLabel>Team</PanelStatLabel>
        {(productivity.teamRows || []).map((row) => (
          <div key={row.id} style={{ fontSize: '0.78rem', marginBottom: 8, lineHeight: 1.4 }}>
            <strong>{row.name}</strong>
            <div style={{ color: '#888' }}>
              {row.hoursWeek}h · {row.billablePct}% billable · {row.deliverables} deliverables
            </div>
          </div>
        ))}
      </PanelStatRow>
    </CommunicationsSidePanel>
  );
}
